import styled from 'styled-components';
import { typography } from '@cld/typography';
import { globalTheme } from '@cld/component-theme';
import { Icon } from '@cld/icon';
import { ItemProps, SuppportedLayoutTypographySize } from '../types';

export type LayoutBaseProps = Pick<ItemProps, 'isSelected' | 'selectionVariant' | 'showCheckIconWhenSelected' | 'size'>;

export const layoutTypographyMixin = (size: SuppportedLayoutTypographySize) => (props: Required<LayoutBaseProps>) =>
  props.isSelected ? (props.selectionVariant === 'subtle' ? typography[size].url : typography[size].contrastInvert) : typography[size].regular;

export const ActionsWrapper = styled.div`
  margin-left: auto;
  margin-right: ${globalTheme.spacing.xs};
  color: ${globalTheme.palette.contrastLow};
`;

export const SelectedIcon = styled(Icon).attrs({ name: 'check', size: 'sm', 'data-test': 'check-icon' })`
  margin-left: auto;
  margin-right: ${globalTheme.spacing.sm};

  ${ActionsWrapper} + & {
    margin-left: 0;
  }
`;
